import { createReducer, on } from "@ngrx/store";
import { loadCatalogProducts, loadCatalogProductsFailed, loadCatalogProductsSuccess, updateCatalogProductActivities } from "../actions/catalog-products.actions";
import { catalogInitialState } from "../initial-states/catalog.state";
import { CatalogProduct } from "src/app/models/portal.model";
import { PlatformEnum, PlatformNameEnum } from "src/app/models/enums.model";
import { ProductActivity } from "src/app/models/user-products.model";

export const CatalogReducer = createReducer(catalogInitialState,

	// The reducer runs when a dispatch 'loadCatalogProducts' was triggered
	// The only thing we need to do here is to set the loading to true
	on(loadCatalogProducts,
		(state, { productType }) => {
			const newState = { ...state }
			newState[productType] = { ...state[productType], loading: true };
			return newState;
		}
	),

	// The reducer runs when a dispatch 'loadPortalSettingsSuccess' was triggered
	// Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the catalog for the specific type
	on(loadCatalogProductsSuccess,
		(state, { productType, catalogProducts }) => {
			const newState = { ...state }
			newState[productType] = { ...state[productType], loading: false, loadedOnce: true, value: ParseProducts(catalogProducts) };
			return newState;
		}
	),

	// The reducer runs when a dispatch 'loadCatalogProductsFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(loadCatalogProductsFailed,
		(state, { productType, error }) => {
			const newState = { ...state }
			state[productType] = { ...state[productType], loading: false, loadedOnce: false, error };
			return newState;
		}
	),

	// The reducer runs when a dispatch 'updateCatalogProductActivities' was triggered
	// Here we need to update the value of the product activities
	on(updateCatalogProductActivities,
		(state, { productType, productId, productActivities }) => {
			const newState = { ...state }
			newState[productType] = { ...state[productType], value: updateProductActivity(state[productType].value, productId, productActivities) };
			return newState;
		}
	)
)

// Function to update the list of resources
function ParseProducts(products: CatalogProduct[]) {

	// For all prodcuts convert platform string value to enum value
	products.forEach(prod => {
		if (prod.platforms) {
			const platforms = [...prod.platforms];
			prod.platforms = [];
			prod.platformNames = [];
			platforms.forEach(p => {
				switch (p) {
					case "teams":
						prod.platforms.push(PlatformEnum.MicrosofTeams);
						prod.platformNames.push(PlatformNameEnum.MicrosofTeams);
						break;
					case "sharepoint":
					case "spo2013":
						prod.platforms.push(PlatformEnum.SharePoint);
						prod.platformNames.push(PlatformNameEnum.SharePoint);
						break;
					case "powerbi":
						prod.platforms.push(PlatformEnum.PowerBI);
						prod.platformNames.push(PlatformNameEnum.PowerBI);
						break;
					case "planner":
						prod.platforms.push(PlatformEnum.Planner);
						prod.platformNames.push(PlatformNameEnum.Planner);
						break;
					case "project":
						prod.platforms.push(PlatformEnum.Project);
						prod.platformNames.push(PlatformNameEnum.Project);
						break;
					default:
						break;
				}
			});
		}
	});

	return products;
}

function updateProductActivity(currentCatalogProducts: CatalogProduct[], productId: string, activities: ProductActivity[]): CatalogProduct[] {
	const catalogProductToUpdateIndex = currentCatalogProducts.findIndex(x => x.id === productId);
	if (catalogProductToUpdateIndex !== -1) {
		currentCatalogProducts[catalogProductToUpdateIndex].activities = activities
	}
	return currentCatalogProducts;
}
